import { render } from "./CompanyFooter.vue?vue&type=template&id=6224c8d4&scoped=true"
import script from "./CompanyFooter.vue?vue&type=script&lang=js"
export * from "./CompanyFooter.vue?vue&type=script&lang=js"

import "./CompanyFooter.vue?vue&type=style&index=0&id=6224c8d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6224c8d4"]])

export default __exports__